import { ActionButtonConfig, appConst } from '@/lib';
import base from "./base"
import ComboboxItem from '@/store/shared/entity/combobox-item';
import moment from "moment";
import FileUploadInfo from '@/store/shared/entity/file-info';

export default class Render {
    actions(buttons: Array<ActionButtonConfig>, other?: () => {}, reduce: boolean = true){
        return {
            title: base.L("Action.Actions"),
            key: "Actions",
            width: 150,
            ...(other ? other() : {}),
            render: (h: any, params: any) => {
                let shouldButtons = [];
                buttons.forEach(item => {
                    if(window.basic.auth.hasPermission(item.permission)){
                        let checkFunction: Function = item.check;
                        if (checkFunction != undefined) {
                            if (checkFunction(params.row)) {
                                shouldButtons.push(item.label);
                            }
                        } else {
                            shouldButtons.push(item.label);
                        }
                    }
                })
                return this.actionButton(h, params.row, buttons, shouldButtons, reduce);
            }
        }
    }

    actionButton(h: any, row: any, authButtonConfigs: Array<ActionButtonConfig>, shouldShowButtons: Array<string>, reduce: boolean){

        //authButtonConfigs有值   shouldShowButtons 为空数组  
        if (!authButtonConfigs || authButtonConfigs.length == 0 || (shouldShowButtons && shouldShowButtons.length == 0)) return h("div", "");

        if (shouldShowButtons == undefined) {
            if (authButtonConfigs.length < 3) {
                let buttons = [];
                authButtonConfigs.forEach(item => {
                    buttons.push(this.commonButton(h, row, item));
                });
                return buttons;
            } else {
                return this.reduceButtons(h, row, authButtonConfigs, reduce);
            }
        }

        let buttonConfigs = authButtonConfigs.filter((x) => { return shouldShowButtons.indexOf(x.label) > -1 });
        if (buttonConfigs.length < 3) {
            let buttons = [];
            buttonConfigs.forEach(item => {
                buttons.push(this.commonButton(h, row, item));
            });
            return buttons;
        } else {  //多个button  render dropdown
            return this.reduceButtons(h, row, buttonConfigs, reduce)
        }
    }

    reduceButtons(h: any, row: any, buttonConfigs: Array<ActionButtonConfig>, reduce: boolean){
        if (reduce) { //需要dropdown
            let dropDownItems = [];
            for (let b of buttonConfigs) {
                if (b.needPoptip) {
                    dropDownItems.push(
                        h("DropdownItem", [
                            h("hi-poptip", {
                                props: {
                                    title: b.popTipContent,
                                    okText: b.poptipOKText || base.L("Action.Ok"),
                                    cancelText: b.poptipCancelText || base.L("Action.Cancel"),

                                },
                                class: 'action-poptip',
                                on: {
                                    "on-ok": () => {
                                        if (b.type) b.callback(row, b.type);
                                        else b.callback(row);
                                    },
                                }
                            }, [
                                h("div", base.L(b.label))
                            ])
                        ])
                    );
                } else {
                    if(b.label=='app.DeclareCustoms.Information')
                    {
                        dropDownItems.push(
                            h("Divider", {style:{margin: "2px 0"}}),
                            h("DropdownItem", [
                                h(
                                    "div",
                                    {
                                        on: {
                                            click: () => {
                                                b.callback(row);
    
                                            }
                                        }
                                    },
                                    base.L(b.label)
                                )
                      
                                
                            ])
                        );

                    }else{
                    dropDownItems.push(
                        h("DropdownItem", [
                            h(
                                "div",
                                {
                                    on: {
                                        click: () => {
                                            b.callback(row);

                                        }
                                    }
                                },
                                base.L(b.label)
                            )
                  
                            
                        ])
                    );
                }
                }
            }
            return h(
                "Dropdown",
                {
                    props: {
                        transfer: true,
                        placement: "bottom-start"
                    }
                },
                [
                    h("a", [
                        h("span", base.L("Action.More")),
                        h("Icon", {
                            props: {
                                type: "ios-arrow-down"
                            }
                        })
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list"
                        },
                        dropDownItems
                    )
                ]
            );
        } else { //不需要dropdown
            let buttons = [];
            for (let b of buttonConfigs) {
                buttons.push(this.commonButton(h, row, b));
            }
            return buttons;
        }
    }

    commonButton(h: any, row: any, buttonConfig: ActionButtonConfig){
        if (buttonConfig.needPoptip) {
            return h("Poptip", {
                props: {
                    transfer: true,
                    confirm: true,
                    title: buttonConfig.popTipContent,
                },
                on: {
                    "on-ok": async () => {
                        if (buttonConfig.type) buttonConfig.callback(row, buttonConfig.type);
                        else buttonConfig.callback(row);
                    }
                }
            }, [
                h(
                    "a",
                    {
                        style: {
                            marginRight: "5px",
                        }
                    },
                    base.L(buttonConfig.label)
                )
            ]);
        } else {
            return h(
                "a",
                {
                    style: {
                        marginRight: "5px",
                    },
                    on: {
                        click: () => {
                            buttonConfig.callback(row);
                        }
                    }
                },
                base.L(buttonConfig.label)
            );;
        }
    }

    baseColumn(titleKey: string, width: number, other: any): any {
        let col = {
            title: base.L(titleKey)
        };

        if (width) {
            col['width'] = width
        }

        let result = Object.assign(col, other);

        return result;
    }

    /**
     * Code数据渲染构建器
     *
     * @param {string} dateKey 字段名
     * @param {Array<ComboboxItem>} Code列表
     * @returns {(h: any, params: any) => any}
     */
    codeRender(dateKey: string, codeList: Array<ComboboxItem>): (h: any, params: any) => any{
        return (h: any, params: any) => {
            let value = params.row[dateKey];

            if (!value) return h('span', '');
            if (!codeList) return h('span');
            let code = codeList.find(c => c.value == value);
            if (!code) return h('span', value);

            return h('span', code.displayText);
        };
    }

    /**
     * 列表数据渲染构建器
     *
     * @param {string} dateKey 字段名
     * @param {string} type 类型 ('NewLine': 换行, '|': 竖线分隔符)
     * @returns {(h: any, params: any) => any}
     */
    listRender(dateKey: string, type: string = 'NewLine'): (h: any, params: any) => any {
        return (h: any, params: any) => {
            let value = params.row[dateKey];
            if (!value) return h('span', '');
            var list = typeof value === 'string'
                ? value.split(',')
                : value as Array<string>;

            if (type === '|') {
                return h('span', list.join('|'));
            }
            return list.map(f => h('p', f));
        };
    }

    /**
     * 上传文件数据渲染构建器
     *
     * @param {string} dateKey 字段名
     * @returns {(h: any, params: any) => any}
     */
    uploaderFileRender(dateKey: string): (h: any, params: any) => any {
        return (h: any, params: any) => {
            let fileList = params.row[dateKey] as Array<FileUploadInfo>;

            return (fileList || []).map(fileInfo => {
                return h("p", [this.commonButton(h, params.row, {
                    label: fileInfo.uploadFileName,
                    callback: row => {
                        let url = appConst.remoteServiceBaseUrl + "/" + appConst.uploadUrl.previewAction + "?id=" + fileInfo.fileId;
                        window.open(url);
                    }
                })]);
            });
        };
    }

    /**
     * 日期数据渲染构建器
     *
     * @param {string} dateKey 字段名
     * @param {string} [format="YYYY-MM-DD"] 格式
     * @returns {(h: any, params: any) => any}
     */
    dateRender(dateKey: string, format: string = "YYYY-MM-DD"): (h: any, params: any) => any {
        return (h: any, params: any) => {
            let date = params.row[dateKey];
            if (!date) {
                return h('span', '');
            }
            return h('span', moment(date).format(format));
        };
    }

    /**
     * 时间数据渲染构建器
     *
     * @param {string} dateKey 字段名
     * @param {string} [format="YYYY-MM-DD HH:mm:ss"] 格式
     * @returns {(h: any, params: any) => any}
     */
    datetimeRender(dateKey: string, format: string = "YYYY-MM-DD HH:mm:ss"): (h: any, params: any) => any {
        return this.dateRender(dateKey, format);
    }

    /**
     * 日期区间数据渲染构建器
     *
     * @param {string} fromDateKey 开始时间字段名
     * @param {string} toDateKey 结束时间字段名
     * @param {string} [format="YYYY-MM-DD"] 格式
     * @returns {(h: any, params: any) => any}
     */
    dateRangeRender(fromDateKey: string, toDateKey: string, format: string = "YYYY-MM-DD"): (h: any, params: any) => any {
        return (h: any, params: any) => {
            let fromDate = params.row[fromDateKey];
            let toDate = params.row[toDateKey];
            if (!fromDate || !toDate) {
                return h('span', '');
            }
            return h('span',
                moment(fromDate).format(format) +
                '~' +
                moment(toDate).format(format));
        };
    }

    /**
     * 时间区间数据渲染构建器
     *
     * @param {string} fromDateKey 开始时间字段名
     * @param {string} toDateKey 结束时间字段名
     * @param {string} [format="YYYY-MM-DD HH:mm:ss"] 格式
     * @returns {(h: any, params: any) => any}
     */
    datetimeRangeRender(fromDateKey: string, toDateKey: string, format: string = "YYYY-MM-DD HH:mm:ss"): (h: any, params: any) => any {
        return this.dateRangeRender(fromDateKey, toDateKey, format);
    }

    /**
     * Code列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} dataKey 字段名
     * @param {() => any} Code 列表方法
     * @param {any} [other={}}] 其他参数
     * @returns {any}
     */
    codeColumn(titleKey: string, dataKey: string, codeListAction: () => any, other: any = {}): any {
        return this.baseColumn(titleKey, 0, {
            render: (h: any, params: any) => {
                return this.codeRender(dataKey, codeListAction())(h, params);
            },
            ...other
        });
    }

    /**
     * 列表列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} dataKey 字段名
     * @param {string} type 类型 ('NewLine': 换行, '|': 竖线分隔符)
     * @param {any} [other={}}] 其他参数
     * @returns {any}
     */
    listColumn(titleKey: string, dataKey: string, type: string = 'NewLine', other: any = {}): any {
        return this.baseColumn(titleKey, 0, {
            render: this.listRender(dataKey, type),
            ...other
        });
    }

    /**
     * 上传文件控件列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} dataKey 字段名
     * @param {any} [other={}}] 其他参数
     * @returns {any}
     */
    uploaderFileColumn(titleKey: string, dataKey: string, other: any = {}): any {
        return this.baseColumn(titleKey, 0, {
            render: this.uploaderFileRender(dataKey),
            ...other
        });
    }

    /**
     * 日期列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} dataKey 字段名
     * @param {any} [other={}}] 其他参数
     * @param {string} [format="YYYY-MM-DD"] 格式
     * @returns {any}
     */
    dateColumn(titleKey: string, dataKey: string, other: any = {}, format: string = "YYYY-MM-DD"): any {
        return this.baseColumn(titleKey, 120, {
            render: this.dateRender(dataKey, format),
            ...other
        });
    }

    dateMonthColumn(titleKey: string, dataKey: string, other: any = {}, format: string = "YYYY-MM"): any {
        return this.baseColumn(titleKey, 120, {
            render: this.dateRender(dataKey, format),
            ...other
        });
    }

    /**
     * 时间列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} dataKey 字段名
     * @param {any} [other={}}] 其他参数
     * @param {string} [format="YYYY-MM-DD HH:mm:ss"] 格式
     * @returns {any}
     */
    datetimeColumn(titleKey: string, dataKey: string, other: any = {}, format: string = "YYYY-MM-DD HH:mm:ss"): any {
        return this.baseColumn(titleKey, 100, {
            render: this.datetimeRender(dataKey, format),
            ...other
        });
    }

    /**
     * 日期区间列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} fromDateKey 开始时间字段名
     * @param {string} toDateKey 结束时间字段名
     * @param {any} [other={}}] 其他参数
     * @param {string} [format="YYYY-MM-DD"] 格式
     * @returns {any}
     */
    dateRangeColumn(titleKey: string, fromDateKey: string, toDateKey: string, other: any = {}, format: string = "YYYY-MM-DD"): any {
        return this.baseColumn(titleKey, 170, {
            render: this.dateRangeRender(fromDateKey, toDateKey, format),
            ...other
        });
    }

    /**
     * 时间区间列
     *
     * @param {string} titleKey 标题多语言
     * @param {string} fromDateKey 开始时间字段名
     * @param {string} toDateKey 结束时间字段名
     * @param {any} [other={}}] 其他参数
     * @param {string} [format="YYYY-MM-DD HH:mm:ss"] 格式
     * @returns {any}
     */
    datetimeRangeColumn(titleKey: string, fromDateKey: string, toDateKey: string, other: any = {}, format: string = "YYYY-MM-DD HH:mm:ss"): any {
        return this.baseColumn(titleKey, 310, {
            render: this.datetimeRangeRender(fromDateKey, toDateKey, format),
            ...other
        });
    }


}